/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ source: NonNullable<unknown> }} Plan_Manage_Payment_ThroughInputs */

const en_plan_manage_payment_through = /** @type {(inputs: Plan_Manage_Payment_ThroughInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can manage your payment method through ${i?.source}`)
};

const es_plan_manage_payment_through = /** @type {(inputs: Plan_Manage_Payment_ThroughInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puedes administrar tu método de pago a través de ${i?.source}`)
};

/**
* | output |
* | --- |
* | "You can manage your payment method through {source}" |
*
* @param {Plan_Manage_Payment_ThroughInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_manage_payment_through = /** @type {((inputs: Plan_Manage_Payment_ThroughInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Manage_Payment_ThroughInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_manage_payment_through(inputs)
	return en_plan_manage_payment_through(inputs)
});